import permission from "@/middlewares/permission";


function loadView( view ) {
    return () => import(`@/views/admin/roles/${ view }.vue`);
}


const Index = loadView( 'Index' );
const Edit = loadView( 'Edit' );


const roleRoutes = [
    {
        path: 'roles',
        name: 'api.levels.getList',
        component: Index,
        meta: {
            middleware: permission,
            transitionName: 'slide',
        }
    },
    {
        path: 'roles/:id/edit',
        name: 'api.levels.update',
        component: Edit,
        meta: {
            middleware: permission,
            transitionName: 'slide',
        }
    },
];

export default roleRoutes;
